import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateAlignerMaterialSchema } from "../schema/updateAlignerMaterialSchema";
import { updatePaymentInformation } from "../../../api/caseApi";
import { getAllAlignerMaterials } from "../../../api/alignerMaterialsApi";
import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Controller } from "react-hook-form";
const UpdateAlignerMaterialDialog = ({
  openUpdatePaymentInformation,
  handleCloseUpdatePaymentInformation,
  caseId,
  currentAlignerMaterial,
  handleSetAlignerMaterial,
  getCaseData,
}) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(updateAlignerMaterialSchema),
  });

  const [alignerMaterials, setAlignerMaterials] = useState([]);

  useEffect(() => {
    const fetchAlignerMaterials = async () => {
      const response = await getAllAlignerMaterials();
      setAlignerMaterials(response);
    };

    fetchAlignerMaterials();

    let defaultValues = {};
    defaultValues.caseId = caseId;
    defaultValues.alignerMaterialId = currentAlignerMaterial?.id;
    reset({ ...defaultValues });
  }, [caseId, reset, currentAlignerMaterial]);

  const submitUpdateAlignerMaterial = async (values) => {
    const response = await updatePaymentInformation(values);
    handleSetAlignerMaterial(response.data.data);
    await getCaseData();
    handleCloseUpdatePaymentInformation();
  };

  return (
    <div>
      <StyledDialog
        open={openUpdatePaymentInformation}
        onClose={handleCloseUpdatePaymentInformation}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Update Aligner Material</DialogTitle>
        <form onSubmit={handleSubmit(submitUpdateAlignerMaterial)}>
          <DialogContent dividers>
            <Grid container spacing={1}>
              <Grid item xs={7}>
                <Controller
                  control={control}
                  name="alignerMaterialId"
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <Autocomplete
                      options={alignerMaterials}
                      defaultValue={currentAlignerMaterial?.name}
                      onChange={(_, val) => {
                        onChange(val?.id || "");
                      }}
                      getOptionLabel={(option) => option.name || option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(error)}
                          FormHelperTextProps={{ variant: "standard" }}
                          helperText={error && error.message}
                          placeholder="Aligner Material"
                        />
                      )}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        );
                      }}
                      sx={{ width: "100%" }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              onClick={handleCloseUpdatePaymentInformation}
              disabled={isSubmitting}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateAlignerMaterialDialog;
